var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'pb-button-block': true, full: _vm.full }},[_c('button',{class:( _obj = { 'pb-button': true }, _obj[_vm.size] = true, _obj[_vm.color] = true, _obj.ghost = _vm.ghost, _obj ),style:(_vm.stylus),attrs:{"disabeld":_vm.disabeld ? true : false},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }